(function () {
  'use strict';

  function getStep(scrollEl) {
    var row = scrollEl.querySelector('.testimonials__row');
    var card = scrollEl.querySelector('.testimonials__card');
    if (!card || !row) return Math.max(120, Math.floor(scrollEl.clientWidth * 0.75));
    var cs = window.getComputedStyle(row);
    var gap = parseFloat(cs.columnGap || cs.gap) || 0;
    return Math.ceil(card.getBoundingClientRect().width + gap);
  }

  function hasOverflow(scrollEl) {
    return scrollEl.scrollWidth - scrollEl.clientWidth > 1;
  }

  function applyNavState(scrollEl, prevBtn, nextBtn, state) {
    if (!hasOverflow(scrollEl)) {
      prevBtn.hidden = true;
      nextBtn.hidden = true;
      prevBtn.setAttribute('tabindex', '-1');
      nextBtn.setAttribute('tabindex', '-1');
      return;
    }
    prevBtn.hidden = state.atStart;
    nextBtn.hidden = state.atEnd;
    prevBtn.setAttribute('tabindex', state.atStart ? '-1' : '0');
    nextBtn.setAttribute('tabindex', state.atEnd ? '-1' : '0');
  }

  function initTestimonials(root) {
    if (root.getAttribute('data-testimonials-init') === '1') return;

    var scrollEl = root.querySelector('.testimonials__scroll');
    var rowEl = root.querySelector('.testimonials__row');
    var prevBtn = root.querySelector('.testimonials__nav--prev');
    var nextBtn = root.querySelector('.testimonials__nav--next');
    var startEdge = root.querySelector('[data-testimonials-edge="start"]');
    var endEdge = root.querySelector('[data-testimonials-edge="end"]');
    if (!scrollEl || !rowEl || !prevBtn || !nextBtn) return;

    root.setAttribute('data-testimonials-init', '1');

    var state = { atStart: true, atEnd: false };

    function onIntersect(entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.target === startEdge) state.atStart = entry.isIntersecting;
        else if (entry.target === endEdge) state.atEnd = entry.isIntersecting;
      }
      applyNavState(scrollEl, prevBtn, nextBtn, state);
    }

    var io = null;
    if (typeof IntersectionObserver !== 'undefined' && startEdge && endEdge) {
      io = new IntersectionObserver(onIntersect, {
        root: scrollEl,
        rootMargin: '0px',
        threshold: 0.99,
      });
      io.observe(startEdge);
      io.observe(endEdge);
    }

    function flushFromScroll() {
      if (!hasOverflow(scrollEl)) {
        applyNavState(scrollEl, prevBtn, nextBtn, state);
        return;
      }
      if (io && typeof io.takeRecords === 'function') {
        var pending = io.takeRecords();
        if (pending.length) onIntersect(pending);
      }
      var max = scrollEl.scrollWidth - scrollEl.clientWidth;
      var left = scrollEl.scrollLeft;
      state.atStart = left <= 1;
      state.atEnd = left >= max - 1;
      applyNavState(scrollEl, prevBtn, nextBtn, state);
    }

    prevBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (prevBtn.hidden) return;
      scrollEl.scrollBy({ left: -getStep(scrollEl), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (nextBtn.hidden) return;
      scrollEl.scrollBy({ left: getStep(scrollEl), behavior: 'smooth' });
    });

    scrollEl.addEventListener('scroll', flushFromScroll, { passive: true });
    scrollEl.addEventListener('scrollend', flushFromScroll);
    window.addEventListener('resize', flushFromScroll);

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(flushFromScroll);
      ro.observe(scrollEl);
      ro.observe(rowEl);
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(flushFromScroll);
    });
    flushFromScroll();
  }

  function run() {
    var roots = document.querySelectorAll('[data-testimonials-root]');
    for (var i = 0; i < roots.length; i++) initTestimonials(roots[i]);
  }

  function bindOnce() {
    if (window.__testimonialsSliderBound) return;
    window.__testimonialsSliderBound = true;

    document.addEventListener('shopify:section:load', function (event) {
      var target = event.target;
      var root = target.querySelector && target.querySelector('[data-testimonials-root]');
      if (root) initTestimonials(root);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
  }

  bindOnce();
  run();
})();
